import { Spinner, VStack } from '@chakra-ui/react';

export const LoadingSpinner = () => {
  return (
    <VStack>
      <Spinner color="blue.500" size="lg" />
    </VStack>
  );
};
